import { createContext, useContext } from "react";
import { initialState, PaymentsClientState } from "./state";

export type PaymentsClientStateContextValue = {
  state: PaymentsClientState;
};

export const PaymentsClientStateInitialState: PaymentsClientStateContextValue = {
  state: initialState,
};

export const PaymentsClientStateContext = createContext<PaymentsClientStateContextValue>(
  PaymentsClientStateInitialState
);

export const {
  Provider: PaymentsStateContextProvider,
} = PaymentsClientStateContext;

export const usePaymentsClientStateContext = (): PaymentsClientStateContextValue =>
  useContext<PaymentsClientStateContextValue>(PaymentsClientStateContext);
